// src/lib/partner/partnerSettings.js
import { supabase } from "../../supabaseClient";

function normalisePartnerSettings(row) {
  return {
    id: row?.id || "",
    name: row?.name || "",
    slug: row?.slug || "",
    status: row?.status || "",
    description: row?.description || "",
    contact_email: row?.contact_email || "",
    contact_phone: row?.contact_phone || "",
    website: row?.website || "",
    address: row?.address || "",
    created_at: row?.created_at || null,
    updated_at: row?.updated_at || null,
    can_manage: Boolean(row?.can_manage),
  };
}

export async function fetchPartnerSettings(partnerId) {
  if (!partnerId) {
    throw new Error(
      "A partner organisation ID is required."
    );
  }

  const { data, error } = await supabase
    .rpc("get_partner_settings", {
      p_partner_id: partnerId,
    })
    .maybeSingle();

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error(
      "The partner organisation settings could not be found."
    );
  }

  return normalisePartnerSettings(data);
}

export async function updatePartnerSettings(
  partnerId,
  values
) {
  if (!partnerId) {
    throw new Error(
      "A partner organisation ID is required."
    );
  }

  const { data, error } = await supabase
    .rpc("update_partner_settings", {
      p_partner_id: partnerId,
      p_name: String(values?.name || "").trim(),
      p_description: String(
        values?.description || ""
      ).trim(),
      p_contact_email: String(
        values?.contact_email || ""
      )
        .trim()
        .toLowerCase(),
      p_contact_phone: String(
        values?.contact_phone || ""
      ).trim(),
      p_website: String(
        values?.website || ""
      ).trim(),
      p_address: String(
        values?.address || ""
      ).trim(),
    })
    .maybeSingle();

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error(
      "The organisation settings could not be updated."
    );
  }

  return normalisePartnerSettings(data);
}